import { zodResolver } from '@hookform/resolvers/zod'
import { ZodSchema } from 'zod'

export function createFormSchema<T extends ZodSchema>(schema: T) {
  return {
    resolver: zodResolver(schema as any),
  }
}
